import { NgModule } from '@angular/core';
import {EditSharedModule} from "../../shared/EditShared.module";
import {StoryboardEditRoutingModule} from "./storyboard-edit-routing.module";
import { EditModal } from './shared/edit-modal.service';
import { TranscribeComponent } from './transcribe/transcribe.component';
import {TranscribeService} from "./shared/transcribe.service";
import { TranscribeProgressBarComponent } from './transcribe/transcribe-progress-bar/transcribe-progress-bar.component';
import {HttpClientModule} from "@angular/common/http";
import {TranslateService} from "./shared/translate.service";
import { KenBurnsPresetComponent } from './ken-burns-preset/ken-burns-preset.component';

@NgModule({
  imports: [
    StoryboardEditRoutingModule,
    EditSharedModule,
    HttpClientModule,
  ],
  providers: [
    EditModal,
    TranscribeService,
    TranslateService
  ],
  declarations: [TranscribeComponent, TranscribeProgressBarComponent, KenBurnsPresetComponent],
  entryComponents: [TranscribeComponent, KenBurnsPresetComponent]
})
export class StoryboardEditModule { }



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/storyboard-edit.module.ts